<template lang="pug">
  .page__wr
    .contacts
      .contacts__wr
        .contacts__title-wr.title-oblique-line-anima
          h1.contacts__title.title-anima
            | {{h1}}
        .contacts__content
          .contacts__left
            .contacts__address-items
              .contacts__address-item(v-if="address")
                .contacts__address-item-left
                  SvgIcon(class='contacts__address-item-ico' name="placeholder" width="20" height="29")
                .contacts__address-item-right(v-html="address")
              .contacts__address-item(v-if="insta")
                .contacts__address-item-left
                  SvgIcon(class='contacts__address-item-ico contacts__address-item-ico--insta' name="insta" width="24" height="24")
                .contacts__address-item-right(v-html="insta")
              .contacts__address-item(v-if="phones")
                .contacts__address-item-left
                  SvgIcon(class='contacts__address-item-ico' name="phone" width="21" height="21")
                .contacts__address-item-right(v-html="phones")
              .contacts__address-item(v-if="schedule")
                .contacts__address-item-left
                  SvgIcon(class='contacts__address-item-ico' name="clock" width="24" height="24")
                .contacts__address-item-right(v-html="schedule")

          .contacts__right
            .contacts__map#contactsMap
              .contacts__map-preloader

      BottomNav(:links="links")
      Samedia
</template>

<script>
import EventBus from '@/eventBus';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import FormBooking from '@/components/common/formBooking/FormBooking.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

// @ is an alias to /src


import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {YaHelpersVue} from '@/mixins/YaHelpersVue';

export default {
  name: 'Contacts',

  mixins: [AjaxHelpersVue, YaHelpersVue],

  components: {
    BottomNav,
    SvgIcon,
    FormBooking,
    Samedia
  },

  data() {
    return {
      isMapInit: false,
      address: null,
      insta: null,
      phones: null,
      schedule: null,
      links: {
        prev: {
          href: "/galereya",
          txt: "Галерея"
        },
        next: {
          href: "/",
          txt: "Главная"
        }
      },
      btn: false
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadContactsPage', url => {
      this.request(url);
    });
  },

  methods: {
    request(url) {
      this.req('ContactsPage:getContactsPage', {url}, res => {
        if (this.checkProperty(res.content.address)) {
          this.address = res.content.address;
        }

        if (this.checkProperty(res.content.insta)) {
          this.insta = res.content.insta;
        }

        if (this.checkProperty(res.content.phones)) {
          this.phones = res.content.phones;
        }

        if (this.checkProperty(res.content.schedule)) {
          this.schedule = res.content.schedule;
        }

        if (this.checkProperty(res.content.initMapConfig)) {

          this.$nextTick(() => {
            if (!this.isMapInit) {
              this.initMapLocal(res.content.initMapConfig);
            }
          });
        }
        EventBus.$emit('pageDone');
      }, 'contacts');
    },

    initMapLocal(initMapConfig) {
      this
          // Передаем в карту её ид и объект настроек
          .initMap('contactsMap', initMapConfig)
          // Когда карта загружена
          .then(() => {
            // Добавляем на карту placemarks
            this.addAllPlacemarks(initMapConfig.coords).then(() => {

              setTimeout(() => {
                $('.contacts__map-preloader').addClass('contacts__map-preloader--hide');
              }, 750);
            });

            this.isMapInit = true;
          });
    }
  }
}
</script>

<style>
.contacts {
  position: relative;
  height: 96%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
